import React from 'react'
import { Ordering } from 'storfox-filter'

import { VARIANT_COLUMNS as tableColumns } from './VariantTable'

import { FILTER_NAME as name } from '../../constants'

export const variantOrderingOptions = {
  name,
  tableColumns
}

function VariantOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default VariantOrderingForm
